import DetailPageLayout from "../Layout/DetailPageLayout";
import {
  ContentContainer,
  RegisterHeaderText,
  CheckboxWrapper,
  CheckboxTerms,
  CheckboxTermWrapper,
  CheckboxLabel,
  Checkbox,
  DetailTermBtn,
  NextButton,
  NextButtonText,
  RegisterHeader,
  RegisterWrapper,
} from "./RegisterTermsService.styles";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { TermService, TermCollect } from "./RegisterTermsService.helpers";

const RegisterTermsService = () => {
  const navigate = useNavigate();
  const [checkList, setCheckList] = useState([]);
  const [isCheckTerms, setIsCheckTerms] = useState(false);
  const [isShowTerm, setIsShowTerm] = useState("");

  const checkAllTerms = (e) => {
    e.target.checked
      ? setCheckList(["checkService", "checkCollect", "checkAnother"])
      : setCheckList([]);
  };

  const checkOneTerm = (e) => {
    e.target.checked
      ? setCheckList([...checkList, e.target.id])
      : setCheckList(checkList.filter((choiceId) => choiceId !== e.target.id));
  };

  const showTerm = (e) => {
    const currentId = e.target.id;
    if (isShowTerm !== currentId) {
      setIsShowTerm(e.target.id);
    } else {
      setIsShowTerm("");
    }
  };

  // 필수 조건이 전부 체크되어있으면 NextBtn 활성화
  useEffect(() => {
    if (
      checkList.includes("checkService") &&
      checkList.includes("checkCollect")
    ) {
      setIsCheckTerms(true);
    } else {
      setIsCheckTerms(false);
    }
  }, [checkList]);

  const goNext = () => {
    if (isCheckTerms) navigate("/register/username");
  };

  return (
    <DetailPageLayout headerText="이용약관">
      <ContentContainer>
        <RegisterHeader>
          <RegisterHeaderText>
            <div>넥스트 에너지 모바일에 오신것을 환영합니다.</div>
            <div>아래의 약관 동의 및 회원가입이 필요합니다.</div>
          </RegisterHeaderText>
        </RegisterHeader>
        <RegisterWrapper>
          <CheckboxWrapper>
            <CheckboxLabel htmlFor="checkAll">
              <CheckboxTermWrapper>
                <Checkbox
                  type="checkbox"
                  id="checkAll"
                  onChange={checkAllTerms}
                  checked={checkList.length === 3 ? true : false}
                ></Checkbox>
                약관 전체동의
              </CheckboxTermWrapper>
            </CheckboxLabel>
            <CheckboxTerms>
              <CheckboxTermWrapper>
                <CheckboxLabel htmlFor="checkService">
                  <Checkbox
                    type="checkbox"
                    id="checkService"
                    onChange={checkOneTerm}
                    checked={checkList.includes("checkService") ? true : false}
                  ></Checkbox>
                  서비스이용약관(필수)
                </CheckboxLabel>
                <DetailTermBtn id="service" onClick={showTerm}>
                  상세보기
                </DetailTermBtn>
              </CheckboxTermWrapper>
              {isShowTerm === "service" ? <TermService></TermService> : null}
              <CheckboxTermWrapper>
                <CheckboxLabel htmlFor="checkCollect">
                  <Checkbox
                    type="checkbox"
                    id="checkCollect"
                    onChange={checkOneTerm}
                    checked={checkList.includes("checkCollect") ? true : false}
                  ></Checkbox>
                  개인정보수집(필수)
                </CheckboxLabel>
                <DetailTermBtn id="collect" onClick={showTerm}>
                  상세보기
                </DetailTermBtn>
              </CheckboxTermWrapper>
              {isShowTerm === "collect" ? <TermCollect></TermCollect> : null}
              {/* <CheckboxTermWrapper>
                <CheckboxLabel htmlFor="checkAnother">
                  <Checkbox
                    type="checkbox"
                    id="checkAnother"
                    onChange={checkOneTerm}
                    checked={checkList.includes("checkAnother") ? true : false}
                  ></Checkbox>
                  제3자 제공동의(선택)
                </CheckboxLabel>
                <DetailTermBtn id="another" onClick={showTerm}>
                  상세보기
                </DetailTermBtn>
              </CheckboxTermWrapper> */}
              {/* {isShowTerm === "another" ? (
                <DetailTerm>제 3자 제공동의(선택)</DetailTerm>
              ) : null} */}
            </CheckboxTerms>
          </CheckboxWrapper>
        </RegisterWrapper>

        <NextButton onClick={goNext} color={isCheckTerms}>
          <NextButtonText color={isCheckTerms}>다음</NextButtonText>
        </NextButton>
      </ContentContainer>
    </DetailPageLayout>
  );
};

export default RegisterTermsService;
